import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { ItemChainChip } from "./ItemChainChip";
import { ItemMetadataChipFragment } from "./ItemMetadataChip.fragment";
import { ItemOwnersChip } from "./ItemOwnersChip";
import { ItemRarityChip } from "./ItemRarityChip";
import { ItemStandardChip } from "./ItemStandardChip";
import { ItemTokenIdChip } from "./ItemTokenIdChip";
import { ItemTopOfferChip } from "./ItemTopOfferChip";
export function ItemMetadataChip(t0) {
  const $ = _c(24);
  let chip;
  let itemKey;
  let rest;
  if ($[0] !== t0) {
    ({
      chip,
      item: itemKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = chip;
    $[2] = itemKey;
    $[3] = rest;
  } else {
    chip = $[1];
    itemKey = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== itemKey) {
    t1 = readFragment(ItemMetadataChipFragment, itemKey);
    $[4] = itemKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const item = t1;
  switch (chip) {
    case "standard":
      {
        let t2;
        if ($[6] !== item || $[7] !== rest) {
          t2 = <ItemStandardChip item={item} {...rest} />;
          $[6] = item;
          $[7] = rest;
          $[8] = t2;
        } else {
          t2 = $[8];
        }
        return t2;
      }
    case "chain":
      {
        let t2;
        if ($[9] !== item || $[10] !== rest) {
          t2 = <ItemChainChip item={item} {...rest} />;
          $[9] = item;
          $[10] = rest;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        return t2;
      }
    case "token_id":
      {
        let t2;
        if ($[12] !== item || $[13] !== rest) {
          t2 = <ItemTokenIdChip item={item} {...rest} />;
          $[12] = item;
          $[13] = rest;
          $[14] = t2;
        } else {
          t2 = $[14];
        }
        return t2;
      }
    case "top_offer":
      {
        let t2;
        if ($[15] !== item || $[16] !== rest) {
          t2 = <ItemTopOfferChip item={item} {...rest} />;
          $[15] = item;
          $[16] = rest;
          $[17] = t2;
        } else {
          t2 = $[17];
        }
        return t2;
      }
    case "rarity":
      {
        let t2;
        if ($[18] !== item || $[19] !== rest) {
          t2 = <ItemRarityChip item={item} {...rest} />;
          $[18] = item;
          $[19] = rest;
          $[20] = t2;
        } else {
          t2 = $[20];
        }
        return t2;
      }
    case "owners":
      {
        let t2;
        if ($[21] !== item || $[22] !== rest) {
          t2 = <ItemOwnersChip item={item} {...rest} />;
          $[21] = item;
          $[22] = rest;
          $[23] = t2;
        } else {
          t2 = $[23];
        }
        return t2;
      }
  }
}